import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TdDialogService, ITdDataTableColumn, TdDataTableService, TdDataTableSortingOrder, IPageChangeEvent, ITdDataTableSortChangeEvent, TdLoadingService } from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { Piece } from '../../../inventory/piece';
import { PrintingService } from '../../../../shared/services/printing.service';
import { ProductService } from '../../../purchasing/products/product.service';
import { Product } from '../../../purchasing/products/product';
import { SettingsService } from '../../../../shared/services/settings.service';
import {Utils} from '../../../../shared/utils';

@Component({
  selector: 'app-print-product-label',
  templateUrl: './print-product-label.component.html',
  styleUrls: ['./print-product-label.component.scss'],
  providers: [PrintingService]
})
export class PrintProductLabelComponent implements OnInit {
  color_id: string;
  product: Product = new Product();

  products: Product[] = [];

  columns: ITdDataTableColumn[] = [
    { name: 'id', label: 'ID', tooltip: '' },
    { name: 'collection_name', label: 'Collection', tooltip: '' },
    { name: 'design_name', label: 'Design', tooltip: '' },
    { name: 'name', label: 'Color', tooltip: '' },
  ];

  filteredData: any[];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  pageSize: number = 5;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  constructor(private _dialogService: TdDialogService,
    private _dataTableService: TdDataTableService,
    private _productService: ProductService,
    public _settingsService: SettingsService,
    private _printService: PrintingService,
    private location: Location,
    private _loadingService: TdLoadingService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
    this._loadingService.register('loading');

    this._productService.getProducts().subscribe(
      response => {
        if (response != null && Array.isArray(response)) {
          this.products = response;
          this.filter();
        };
        this._loadingService.resolve('loading');
      },
      error => {
        this._loadingService.resolve('loading');
      }
    );

  }

  goBack(): void {
    this.location.back();
  }

  print(color_id: string) {
    this._productService.getOneProduct(color_id).subscribe(
      response => {
        if (response != null) {
          this.product = response;

          this._printService.print(
            {
              collection: this.product.collection_name,
              color: this.product.name,
              design: this.product.design_name,
              part_number: this.product.id,
            }, this._authService.getPrinterId(), 1, 'product').subscribe(
            response => {
              if (response['status'] == 'SUCCESS') {
                this._dialogService.openAlert({
                  message: 'Sent to print queue!',
                  title: 'Success'
                });
              } else {
                this._dialogService.openAlert({
                  message: 'Could not send to print queue!',
                  title: 'Failed'
                });
              }
            }
            );
        } else {
          this._dialogService.openAlert({
            message: 'The product could not be found!',
            title: 'Failed'
          });
        }
      });
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }
  
  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.products;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    newData = this._dataTableService.filterData(newData, this.searchTerm, true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/inventory/print-product-label/print-product-label.component.ts